import { Box, Button, IconButton, Typography } from '@mui/material'
import React, { useState, useEffect, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import Grid from '../Grid/Grid'
import $ from 'jquery'
import Cookies from 'universal-cookie'
import SearchInput from '../../Components/SearchInput'
import { useNavigate } from 'react-router-dom'
import RefreshIcon from '@mui/icons-material/Refresh';
import Preloading from '../../Pages/Preload/Preloading';
import mainUnitsAPI from '../../Network/MainUnit'
import Tooltip from '@mui/material/Tooltip';
import CancelIcon from '@mui/icons-material/Cancel';
import swal from "sweetalert";



const cookies = new Cookies();
const APP_CONSTANTS = {
  API_URL_IMG: `${process.env.REACT_APP_API_URL_image}`,
}

const FilterSearchContent = (props) => {
  const [t] = useTranslation('common')

  return (
    <Box sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: 'column',
      width: '100% !important',
    }}>
      <SearchInput
        value={props?.unitNameSearch}
        setValue={props?.setUnitNameSearch}
        title={t('UNITS.unitName')}

      />
      {/* <Box
        sx={{
          display: 'flex',
          justifyContent: 'start',
          width: '100%',
          marginLeft: '20px !important',
          marginTop: '10px !important',
          '& .MuiTypography-root': {
            fontFamily: 'Cairo-Medium'
          }
        }}>
        <FormControlLabel control={<Switch checked={props.checkAllselected} onChange={(e) => {
          props.setCheckAllselected(e.target.checked)
          if(e.target.checked)
          props.setCheckAllNotSelected(false)

        }} />} label={"المحددة" } />
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'start',
          width: '100%',
          marginLeft: '20px !important',
          marginTop: '10px !important',
          '& .MuiTypography-root': {
            fontFamily: 'Cairo-Medium'
          }
        }}>
        <FormControlLabel control={<Switch checked={props.checkAllNotSelected} onChange={(e) => {
          props.setCheckAllNotSelected(e.target.checked)
          if(e.target.checked)
          props.setCheckAllselected(false)
        }} />} label={'غير محددة'} />
      </Box> */}
    </Box>)
}
const RenderContent = (props) => {
  const [t] = useTranslation('common')

  const [columns, setColumns] = useState([
    // {
    //   ...GRID_CHECKBOX_SELECTION_COL_DEF,
    //   width: 40,
    // },
    { headerName: t('UNITS.ID'), field: 'index', flex: 0.5 },
    { headerName: t('UNITS.unitName'), field: 'nm', flex: 2 },
    { headerName: t('UNITS.barcode'), field: 'barcode', flex: 1 },

    { headerName: t('UNITS.expire_date'), field: 'expire_date', flex: 2 },
    { headerName: t('UNITS.days_left_to_expire'), field: 'days_left_to_expire', flex: 2 },
    // { headerName: t('UNITS.active'), field: 'nm', flex: 2 },
    {
      headerName: t('UNITS.active'), field: 'act', flex: 2, editable: false,

      renderCell: (rows) => (

        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          {
            rows?.row?.update_note?.length > 1 ?
              <Box sx={{ marginLeft: '10px !important', marginRight: '10px !important' }}>


                <Tooltip
                  title={
                    <span style={{ fontFamily: "Cairo-Medium" }}>
                      {rows?.row?.update_note}
                    </span>
                  }
                >
                  <CancelIcon
                    sx={{
                      fill: "#FF0000"
                    }}
                  />
                </Tooltip>
              </Box> : null

          }
          <Box sx={{ marginLeft: '10px !important', marginRight: '10px !important' }}>
            {
              rows?.row?.act == 1 ?
                <span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '75px', color: "white", fontSize: '15px', fontFamily: 'Cairo', backgroundColor: (rows?.row?.days_left_to_expire > 0 && rows?.row?.days_left_to_expire <= 30) ? '#FEAF1A' : '#00E396', padding: "5px", borderRadius: "5px" }}>{"فعال"}</span>
                : <span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '75px', color: 'white', fontSize: '15px', fontFamily: 'Cairo', backgroundColor: '#FE4560', padding: "5px", borderRadius: "5px" }}>{"غير فعال"}</span>
            }</Box>

        </Box>
      )

    },
    // {
    //   headerName: t('UNITS.update_note'), field: 'update_note', flex: 2, editable: false,

    //   renderCell: (rows) => (
    //     <Box>
    //       {
    //         rows?.row?.update_note ? <span style={{ fontSize: '15px', fontFamily: 'Cairo' }}>{rows?.row?.update_note}</span> : <span style={{ color: 'gray', fontSize: '12px', fontFamily: 'Cairo-Light' }}></span>
    //       }
    //     </Box>
    //   )

    // },

  ])
  const [pageSize, setPageSize] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(false)
  const handlePageChange = (newPage) => {
    setPageNumber(newPage + 1);
  };

  const screenwidth = useSelector(state => state.settingsData.screenwidth)
  // const [listOfSelectedRows,setListOfSelectedRows]=useState([])
  const handleCheckBoxChange = useCallback((rows) => {

    props.setListOfSelectedRows(rows)
    let arr = [];
    props?.units && props?.units?.length && props?.units?.map((itm) => {
      if (rows?.find(e => e == itm?.id)) {
        arr.push(itm)
      }
    })

    props.setUnit(arr)
  }, [])
  const handleRowCellChange = (row) => {

    let key = null;
    for (var i in row) {
      key = i;
    }
    let arr = []
    props?.units && props?.units?.length && props?.units?.map((itm) => {
      if (itm?.id == key) {
        arr.push({
          ...itm,
          reason: row[key]?.reason?.value,
        })
      } else {
        arr.push(itm)
      }
    })


    if (arr)
      props.setUnits(arr)
  }





  const getRowClassName = (params) => {


    if (params?.row?.update_note?.length > 1) {
      return 'highlighted-disabled-row'
    }
    return ''
  };
  return (
    <Box className="Container-fluid">
      <Box className="row d-flex justify-content-center align-items-start">
        <Box className="col-12 col-sm-12 col-md-12 my-3 px-0"
          sx={{
            '& .MuiCheckbox-root': {
              color: '#1e6a99 !important',
              fill: '#1e6a99 !important'

            }
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'center',
                marginBottom:'10px'
              }}
            >
              <Typography sx={{
                fontFamily: 'Cairo',
                marginLeft: '10px',
                backgroundColor: "#edf4fb",
                padding: "4px",
                borderRadius: '5px',
                cursor: "pointer", // Hand cursor
                transition: "all 0.2s ease-in-out", // Smooth transition
                border: props?.unitsStatus == null ? "2px solid #1e6a99" : "2px solid transparent", // Border for selected
                fontWeight: props?.unitsStatus == null ? "bold" : "normal", // Bold text if selected
                "&:hover": {
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)", // Raised effect
                  transform: "translateY(-2px)", // Slight lift effect
                },
                "&:active": {
                  transform: "scale(0.95)", // Click effect (shrink slightly)
                },
              }}
                onClick={() => props?.setUnitsStatus(null) /* Replace with your function */}
              >{t('GLOBAL.total') + " : " + props?.allUnits?.length}</Typography>
              <Typography sx={{
                fontFamily: 'Cairo',
                marginLeft: '10px',
                backgroundColor: "#00E396",
                padding: "4px",
                color: "#FFFFFF",
                borderRadius: '5px',
                cursor: "pointer", // Hand cursor
                transition: "all 0.2s ease-in-out", // Smooth transition
                border: props?.unitsStatus == 1 ? "2px solid #1e6a99" : "2px solid transparent", // Border for selected
                fontWeight: props?.unitsStatus == 1 ? "bold" : "normal", // Bold text if selected
                "&:hover": {
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)", // Raised effect
                  transform: "translateY(-2px)", // Slight lift effect
                },
                "&:active": {
                  transform: "scale(0.95)", // Click effect (shrink slightly)
                },
              }}
                onClick={() => props?.unitsStatus == 1?props?.setUnitsStatus(null):props?.setUnitsStatus(1) /* Replace with your function */}
              >{t('GLOBAL.total_active') + " : " + props?.allUnits?.filter(item => item?.act == 1)?.length}</Typography>
              <Typography sx={{
                fontFamily: 'Cairo',
                marginLeft: '10px',
                backgroundColor: "#FE4560",
                padding: "4px",
                color: "#FFFFFF",
                borderRadius: '5px',
                cursor: "pointer", // Hand cursor
                transition: "all 0.2s ease-in-out", // Smooth transition
                border: props?.unitsStatus == 2 ? "2px solid #1e6a99" : "2px solid transparent", // Border for selected
                fontWeight: props?.unitsStatus == 2 ? "bold" : "normal", // Bold text if selected
                "&:hover": {
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)", // Raised effect
                  transform: "translateY(-2px)", // Slight lift effect
                },
                "&:active": {
                  transform: "scale(0.95)", // Click effect (shrink slightly)
                },
              }}
                onClick={() => props?.unitsStatus == 2?props?.setUnitsStatus(null):props?.setUnitsStatus(2) /* Replace with your function */}
              >{t('GLOBAL.total_inactive') + " : " + props?.allUnits?.filter(item => item?.act == 0)?.length}</Typography>
              <Typography sx={{
                fontFamily: 'Cairo',
                marginLeft: '10px',
                backgroundColor: "#FEAF1A",
                padding: "4px",
                color: "#FFFFFF",
                borderRadius: '5px',
                cursor: "pointer", // Hand cursor
                transition: "all 0.2s ease-in-out", // Smooth transition
                border: props?.unitsStatus == 3 ? "2px solid #1e6a99" : "2px solid transparent", // Border for selected
                fontWeight: props?.unitsStatus == 3 ? "bold" : "normal", // Bold text if selected
                "&:hover": {
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)", // Raised effect
                  transform: "translateY(-2px)", // Slight lift effect
                },
                "&:active": {
                  transform: "scale(0.95)", // Click effect (shrink slightly)
                },
              }}
                onClick={() => props?.unitsStatus == 3?props?.setUnitsStatus(null):props?.setUnitsStatus(3) /* Replace with your function */}
              >{t('GLOBAL.total_inactive_in_30_days') + " : " + props?.allUnits?.filter(item => item?.days_left_to_expire > 0 && item?.days_left_to_expire <= 30)?.length}</Typography>

              <Typography sx={{
                fontFamily: 'Cairo',
                marginLeft: '10px',
                backgroundColor: "#e2f079",
                borderRadius: '5px',
                padding: "4px",
              }}>{t('GLOBAL.total_filtered') + " : " + props?.units?.length}</Typography>
              <Typography sx={{
                fontFamily: 'Cairo',
                marginLeft: '10px',
                backgroundColor: "#bdf4c6",
                borderRadius: '5px',
                padding: "4px",
              }}>{t('GLOBAL.SEARCH_RESULT_OF_selected') + " : " + props?.listOfSelectedRows?.length}</Typography>
            </Box>

            {props?.listOfSelectedRows?.length > 0 ?
              <Button
                variant="contained"
                // spacing={2} 
                sx={{
                  // flexGrow: 1,
                  margin: 1,
                  width: '200px !important',
                  minWidth: '200px !important',
                  maxWidth: '200px !important',

                  height: '35px',
                  fontFamily: 'Cairo-Bold'
                }}
                className="iconeFilterSearch"
                onClick={() => {
                  swal({
                    title: t('GLOBAL.are_you_sure'),
                    text: t('GLOBAL.renew_units_selected') + " " + props?.listOfSelectedRows?.length,
                    icon: 'warning',
                    buttons: [t('GLOBAL.no'), t('GLOBAL.yes')],
                    dangerMode: true,
                  }).then(async (renew) => {

                    if (renew) {
                      props?.sendRenewRequest()
                    } else {
                      // alert('canceled')
                    }
                  })
                }}
              >
                {t('GLOBAL.Submit_renew')}
              </Button> : null}

          </Box>
          <Grid
            isRowSelectable={(params) => {
              return params?.row?.update_note?.length == 0
            }}
            getRowClassName={getRowClassName}
            rows={props?.units}
            columns={columns}

            setColumns={setColumns}
            pageSize={pageSize}
            setPageSize={setPageSize}
            pageNumber={pageNumber}
            setPageNumber={setPageNumber}
            loading={loading}
            handlePageChange={handlePageChange}
            rowsTotal={props?.units?.length}
            checkScreenSize={screenwidth}
            pageCount={Math.ceil(props?.units?.length / pageSize)}
            openFilterColumn={null}
            elementClicked={null}
            setOpenFilterColumn={null}
            setColumnFilterValue={null}
            columFilterValue={null}
            clearFunction={props.handleClearInAddvancSearch}
            searchFunction={props.handleSearchInAddvancSearch}
            creatFunction={null}
            ExportFunction={null}
            importFunction={null}
            mapFunction={null}
            telegramFunction={null}
            hasCreate={false}
            hasImport={false}
            hasExport={false}
            hasMap={false}
            hasTetelgram={false}
            filterChilds={<FilterSearchContent
              setUnitNameSearch={props?.setUnitNameSearch}
              unitNameSearch={props?.unitNameSearch}
              setCheckAllselected={props.setCheckAllselected}
              checkAllselected={props.checkAllselected}
              setCheckAllNotSelected={props.setCheckAllNotSelected}
              checkAllNotSelected={props?.checkAllNotSelected}
            />}
            filterHasSelectCounter={false}
            filterHasSelectCounterValue={props?.listOfSelectedRows?.length}
            notHaveAdvancSearch={false}
            hasSelectOption={true}
            handleCheckBoxChange={handleCheckBoxChange}
            listOfSelectedRows={props.listOfSelectedRows}
            handleRowCellChange={handleRowCellChange}
            paginationMode={'client'}
          />
        </Box>
      </Box>
    </Box>
  )
}



export default function Units(props) {
  const [t] = useTranslation('common');
  const [name, setName] = useState(null)
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const [phone, setPhone] = useState(cookies.get('phone'))
  const [requestLocation, setRequestLocation] = useState('');
  const [unitsStatus, setUnitsStatus] = useState(null)
  const [requestType, setRequestType] = useState(null);
  const [requestTypes, setRequestTypes] = useState([]);
  const [unit, setUnit] = useState(null);
  const [units, setUnits] = useState([]);
  const [preferedDate, setPreferedDate] = useState(null);
  const [preferedTime, setPreferedTime] = useState(null);
  const [notes, setNotes] = useState('');
  const [customerName, setCustomerName] = useState(cookies.get('account_name'))
  const [userName, setUserName] = useState(cookies.get('user_name'))
  const [requestDate, setRequestDate] = useState(new Date());
  const globalLoading = useSelector(state => state.settingsData.globalLoading)
  const [status, setStatus] = useState({
    id: 1,
    name: 'جديد'
  })

  const [inprogressDateTime, setInprogressDate] = useState(new Date())
  const [closeingDateTime, setcloseingDate] = useState(new Date())

  const [unitNameSearch, setUnitNameSearch] = useState()
  const [filteredUnits, setFilteredUnits] = useState([])
  const [listOfSelectedRows, setListOfSelectedRows] = useState([])
  const [isSearchApplay, setIsSearchApplay] = useState(false)
  const [checkAllselected, setCheckAllselected] = useState(false)
  const [checkAllNotSelected, setCheckAllNotSelected] = useState(false)

  const [imageList, setImageList] = useState([])

  const getNameOfImage = (file) => {
    const name = file.split("/");
    if (name && name?.length > 0) {
      return name[name?.length - 1];
    }
    return ''
  }



  const clearForm = () => {
    setPhone('')
    setRequestLocation('')
    setRequestType(null)
    setUnit([])
    setListOfSelectedRows([])
    setPreferedDate(null)
    setPreferedTime(null)
    setImageList([])
    setNotes('')
  }
  useEffect(() => {
    if (!props?.object) {
      clearForm()
    }


  }, [props?.addForm, props?.object])

  useEffect(() => {
    getAllUnits()
    // getAllRequestTypes()
  }, [])

  //get all requestTypes here..
  const getAllUnits = async () => {
    if (cookies.get('active_session') && cookies.get('active_session') == 'yes') {
      try {
        setLoading(true)
        let arr = []
        let params = {
          username: cookies.get('user_name'),
          user_id: cookies.get('user_id'),
          account_name: cookies.get('account_name'),
          account_id: cookies.get('account_id'),
          sid: cookies.get('sid'),
          baseurl: cookies.get('baseUrl')
        }
        let result = await mainUnitsAPI.mainUnits({
          params: params
        });
        if (result?.status) {
          setLoading(false)
          if (result?.data && result?.data?.data) {
            let rows = result?.data?.data
            try {
              rows = [...rows].sort((a, b) => a.days_left_to_expire - b.days_left_to_expire)
              setUnits(rows)
            } catch (error) {
              setUnits(result?.data?.data)
            }

          }

          // toast.success(t('NETWORKMESSAGE.addCustomerMessageSuccess'))
          if (result && result?.data && result?.data?.data?.message) {
            if (result?.data?.data?.message?.text == "unauthorized to complete") {
              navigate('/redirect')
            }
          }
        } else {
          setLoading(false)
          toast.error(t('NETWORKMESSAGE.addCustomerMessageError'))
          if (result && result?.data && result?.data?.data?.message) {
            if (result?.data?.data?.message?.text == "unauthorized to complete") {
              navigate('/redirect')
            }
          }
        }
        setLoading(false)
      } catch (error) {
        setLoading(false)
        toast.error(error.message)
      }
    } else {
      // navigate('/redirect')
      navigate('/redirect')
    }
  }
  const sendRenewRequest = async () => {
    if (cookies.get('active_session') && cookies.get('active_session') == 'yes') {
      try {
        setLoading(true)
        let arr = []
        let params = {
          username: cookies.get('user_name'),
          user_id: cookies.get('user_id'),
          account_name: cookies.get('account_name'),
          account_id: cookies.get('account_id'),
          sid: cookies.get('sid'),
          baseurl: cookies.get('baseUrl')
        }


        let result = await mainUnitsAPI.renewRequest({
          data: {
            "renewal_list": units?.filter(item => listOfSelectedRows?.includes(item?.id)).map(item => {
              return {
                "receipt_number": item?.receipt_number_wialon,
                "numbering": item?.numbering_wialon
              }
            }),
            // "sticker_code_list": units?.filter(item=>listOfSelectedRows?.includes(item?.id)).map(item=>item?.barcode),
            "company_name": params?.account_name,
            "account_id": params?.account_id,
            "is_invoice": 1
          }
        });

        if (result && result?.status) {

          if (result?.status && result?.data?.success && result?.data?.data?.url) {
            setLoading(false)
            window.location.href = result?.data?.data?.url
          } else {
            setLoading(false)

            if (result && result?.data && result?.data?.data?.message) {
              toast.error(t('NETWORKMESSAGE.addCustomerMessageError'))
              if (result?.data?.data?.message?.text == "unauthorized to complete") {
                navigate('/redirect')
              }
            }
            else if (result?.data?.data) {
              toast.error(result?.data?.data)
            }
            else {
              toast.error(t('NETWORKMESSAGE.addCustomerMessageError'))
            }

          }
        }
        else {
          if (result?.errorMessage && typeof result?.errorMessage == "string") {
            toast.error(result?.errorMessage);
          } else {
            toast.error(t("NETWORKMESSAGE.messageError"));
          }
        }
        setLoading(false)
      } catch (error) {
        setLoading(false)
        toast.error(error.message)
      }
    } else {
      // navigate('/redirect')
    }
  }
  const handleSearchInAddvancSearch = () => {
    let arr = []
    if (unitNameSearch) {
      setIsSearchApplay(true)

      units && units?.length && units?.map((itm) => {
        if (itm?.nm.includes(unitNameSearch)) {
          arr.push(itm)
        }
      })
      setFilteredUnits(arr)
    } else {
      arr = [...units];
      setFilteredUnits(units)
    }
    if (unitsStatus == 1) {
      setFilteredUnits(arr?.filter(itm => itm?.act==1))
    }
    if (unitsStatus == 2) {
      setFilteredUnits(arr?.filter(itm => itm?.act==0))
    }
    if (unitsStatus == 3) {
      setFilteredUnits(arr?.filter(item => item?.days_left_to_expire > 0 && item?.days_left_to_expire <= 30))
    }
    if (checkAllselected) {
      setFilteredUnits(arr.filter(itm => listOfSelectedRows?.includes(itm?.id)))

    }
    if (checkAllNotSelected) {
      setFilteredUnits(arr.filter(itm => !listOfSelectedRows?.includes(itm?.id)))
    }
    
  }
  useEffect(() => {
    handleSearchInAddvancSearch()
  
    return () => {
      
    }
  }, [unitsStatus])
  
  const handleClearInAddvancSearch = () => {
    setIsSearchApplay(false)
    setUnitNameSearch('')
    setFilteredUnits(units)
    setCheckAllselected(false)

  }


  useEffect(() => {
    if (units) {
      setFilteredUnits(units)
    }
  }, [units])



  return (
    <Box>
      {
        globalLoading ? <Preloading dashboardMode={true} /> : null
      }


      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
          height: '100%',
          justifyContent: 'center',
          alignItems: 'stretch',
          // backgroundColor: '#fff',
          position: 'relative',
          // top:'-25px'
        }}
        className="pb-3"
      >


        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Typography
            variant='h4'
            sx={{
              marginLeft: '10px',
              marginBottom: '10px',
              fontFamily: 'Cairo-Bold',
              fontSize: '23px',
              letterSpacing: '-1px',
            }}>
            {t('UNITS.title')}
          </Typography>
        </Box>

        <Box sx={{ marginRight: '20px', backgroundColor: '#1E6A99', color: '#FFFFFF', width: '43px', height: '40px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}
        >
          <IconButton
            onClick={() => {
              getAllUnits()
            }}
          >

            <RefreshIcon sx={{
              color: '#fff',
              fontSize: '25px',
            }} />
          </IconButton>
        </Box>

      </Box>
      <RenderContent
        phone={phone}
        sendRenewRequest={sendRenewRequest}
        task_id={props?.object?.task_id}
        editMode={props?.object?.task_id ? true : false}
        setPhone={setPhone}
        unitsStatus={unitsStatus}
        setUnitsStatus={setUnitsStatus}
        requestLocation={requestLocation}
        setRequestLocation={setRequestLocation}
        requestType={requestType}
        setRequestType={setRequestType}
        requestTypes={requestTypes}
        unit={unit}
        setUnit={setUnit}
        allUnits={units}
        units={filteredUnits}
        setUnits={setUnits}
        preferedDate={preferedDate}
        setPreferedDate={setPreferedDate}
        preferedTime={preferedTime}
        setPreferedTime={setPreferedTime}
        notes={notes}
        setNotes={setNotes}
        customerName={customerName}
        userName={userName}
        requestDate={requestDate}
        status={status}
        inprogressDateTime={inprogressDateTime}
        closeingDateTime={closeingDateTime}
        setImageList={setImageList}
        imageList={imageList}
        unitNameSearch={unitNameSearch}
        setUnitNameSearch={setUnitNameSearch}
        handleSearchInAddvancSearch={handleSearchInAddvancSearch}
        handleClearInAddvancSearch={handleClearInAddvancSearch}
        setListOfSelectedRows={setListOfSelectedRows}
        listOfSelectedRows={listOfSelectedRows}
        isSearchApplay={isSearchApplay}
        checkAllselected={checkAllselected}
        setCheckAllselected={setCheckAllselected}
        setCheckAllNotSelected={setCheckAllNotSelected}
        checkAllNotSelected={checkAllNotSelected}
        open={props.addForm}
        setOpen={props.setAddForm}
        isFullScreen={true}
      />
    </Box>
  )
}
